import * as React from "react";
import { User } from "../../userTypes";

type Props = {
  user: User;
};

export default class VerificationRequest extends React.Component<Props> {
  componentWillReceiveProps(newProps: Props) {}

  render() {
    const { user } = this.props;

    return (
      <section className="page">
        <table
          style={{
            fontSize: "14px",
            paddingTop: "-20px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={6}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p style={{ flex: 1 }}>Verification requests</p>
                </h3>
              </td>
            </tr>

            {user.verification_request_history != null ? (
              <tr>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Status</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Error reason</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Type</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Created at</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Updated at</b>
                </th>
              </tr>
            ) : (
              <tr />
            )}
          </thead>
          {user.verification_request_history == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td>
                  {" "}
                  There are no verification requests records for this user.{" "}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {user.verification_request_history.map(
                (verification_request, index) => {
                  return (
                    <tr key={index}>
                      <td> {verification_request.status} </td>
                      <td> {verification_request.error_reason} </td>
                      <td> {verification_request.type} </td>
                      <td> {verification_request.created_at} </td>
                      <td> {verification_request.updated_at} </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
      </section>
    );
  }
}
